
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SearchBar from './components/SearchBar';
import PopularStores from './components/PopularStores';
import NewPromocodes from './components/NewPromocodes';
import TopDeals from './components/TopDeals';
import Categories from './components/Categories';
import ExclusiveSection from './components/ExclusiveSection';
import PromoBanner from './components/PromoBanner';
import { usePageSeo } from '../../utils/seo';

export default function Home() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  usePageSeo({
    title: 'Promokod.online - актуальные промокоды и акции магазинов',
    description: 'Актуальные промокоды, акции и скидки популярных магазинов. Находите рабочие предложения, переходите по партнёрским ссылкам и экономьте на покупках каждый день.',
    canonicalPath: '/',
  });

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-orange-50 py-16">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20shopping%20discount%20coupons%20promotional%20codes%20digital%20commerce%20background%20with%20clean%20minimalist%20design%20featuring%20shopping%20bags%20gift%20boxes%20and%20percentage%20symbols%20in%20soft%20blue%20and%20orange%20tones&width=1200&height=600&seq=hero-bg&orientation=landscape')`
          }}
        />
        <div className="relative max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Лучшие промокоды и скидки
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Экономьте на покупках в любимых магазинах. Тысячи актуальных промокодов и купонов ждут вас!
          </p>
          <SearchBar onSearch={handleSearch} />
        </div>
      </section>

      {/* Promo Banner (top position) */}
      <PromoBanner position="top" />

      {/* Categories */}
      <Categories />

      {/* Exclusive Stores */}
      <ExclusiveSection />

      {/* Popular Stores */}
      <PopularStores />

      {/* New Promocodes */}
      <NewPromocodes />

      {/* Promo Banner (middle position) */}
      <PromoBanner position="middle" />

      {/* Top Deals */}
      <TopDeals />

      <Footer />
    </div>
  );
}
